import React from "react";

/**
 * WorkImage — the single way client work is rendered on the site.
 *
 * Two rules it enforces everywhere:
 *
 * 1. Never crop. Uploaded artwork keeps its own aspect ratio (`h-auto`), so a
 *    poster, a square post and a wide banner each render whole. Fixed-ratio
 *    frames with object-cover were slicing the tops off finished designs.
 *
 *    `fill` is the one exception, and it is only for the cover thumbnail in
 *    the work grid. That grid is a set of equal 4:5 tiles — the alignment is
 *    the whole point of it — so the cover has to be cropped to fit. It is a
 *    listing device, not the work: every gallery frame inside a case study
 *    still renders whole. Do not reach for `fill` anywhere else.
 *
 * 2. Discourage casual copying: no context menu, no drag, not selectable.
 *    This is a deterrent, NOT protection — the file is still in the network
 *    tab and any screenshot works. Real protection means watermarking or not
 *    publishing print-resolution files.
 */
export default function WorkImage({
    src,
    alt,
    className = "",
    wrapperClassName = "",
    loading = "lazy",
    fill = false,
    ...rest
}) {
    const block = (e) => e.preventDefault();

    return (
        <div
            className={`img-frame relative overflow-hidden bg-[#EFEBDF] select-none ${wrapperClassName}`}
            onContextMenu={block}
        >
            <img
                src={src}
                alt={alt}
                loading={loading}
                draggable={false}
                onContextMenu={block}
                onDragStart={block}
                className={`${
                    fill
                        ? "absolute inset-0 w-full h-full object-cover"
                        : "block w-full h-auto"
                } select-none pointer-events-none ${className}`}
                style={{ WebkitTouchCallout: "none", WebkitUserSelect: "none", userSelect: "none" }}
                {...rest}
            />
        </div>
    );
}
